import log from 'salvo-lite/log'
import Choices from 'choices.js'

class Select {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._selectElem = elem
        this._choices = null
        if (elem.getAttribute('data-select')) {
            this._customOptions = JSON.parse(elem.getAttribute('data-select'))
        } else {
            this._customOptions = {}
        }
        if (this._customOptions.elem) {
            this._selectElem = this._customOptions.elem
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')

        this.options = Object.assign({
            searchEnabled: false,
            removeItems: false,
            paste: false,
            itemSelectText: '',
            shouldSort: false
        }, JSON.parse(this._elem.dataset.select) || '{}')

        this._choices = new Choices(this._selectElem, this.options)

        log.debug(this.constructor.name, 'Initiated')
    }
}

export default Select



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Select.js